
import { Injectable } from "@angular/core";
import { Loader, LoaderOptions } from "@googlemaps/js-api-loader";
import { environment } from "../../environments/environment";
import { EnvConfigService } from '../env-config.service';

@Injectable({
  providedIn: "root",
})
export class GoogleMapsLoaderService {
  private readonly loader: Loader;

  constructor(private readonly envService: EnvConfigService) {
    const googleMap = this.envService.getEnvData();
    const googleMapKey = googleMap?.mapConfig?.websiteKey;
    const loaderOptions: LoaderOptions = {
      apiKey: googleMapKey || environment.GoogleMapKey,
      version: "quarterly",
      // ✅ "drawing" removed — google.maps.drawing.DrawingManager no longer
      // exists as of Maps JS API v3.65 (removed June 2026). Polygon drawing
      // is now handled by Terra Draw (see add-service-available-citys.component.ts),
      // which only needs the core Maps JS API. "geometry" is kept because
      // computeArea() (used for selectedArea) still depends on it.
      libraries: ["places", "geometry"],
    };
    this.loader = new Loader(loaderOptions);
  }

  load(): Promise<any> {
    if (window.google?.maps) {
      console.log("Google Maps API is already loaded.");
      return Promise.resolve();
    }

    // loader.load() respects the version pin above (importLibrary() does not).
    return this.loader.load().then(() => {
      console.log("Google Maps API loaded successfully.");
    }).catch((error) => {
      console.error("Error loading Google Maps API:", error);
      throw error;
    });
  }
}
